module.exports = new __parcel__URL__("pdf.worker.min.350c093f.js").toString();